import { render, staticRenderFns } from "./Withdrawgsb.vue?vue&type=template&id=a18b7ad4"
import script from "./Withdrawgsb.vue?vue&type=script&lang=js"
export * from "./Withdrawgsb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports